export default "__VITE_ASSET__hlOXOXuO__"